<template>
  <div class="p-grid">
    <div class="p-col-12">
      <div class="card card-w-title">
        <div class="manager-title" v-text="title"></div>
        <DropdownScrollable placeholder="Chọn công ty" :limit="company_obj.limit" :loading="company_obj.loading" :show="$store.getters.type == $constants.TYPE_USER.SUPPER_ADMIN" v-model="company" :options="company_obj.items" :total="company_obj.total" @keyup="emitEvent" @offset="changeOffset" :showClear="true"/>
        <BaseDatatable
          :key="componentKey"
          :tableData="listData"
          :model="dataModel"
          :options="options"
          :filterDefault="filters"
          :getFilterOptions="getFilterOptions"
          :actions="getRowActions()"
          v-on:action-click="onActionClicked"
          @onEventOptions="onEventOptions"
          @onDataChange="DataOnChange"
          :company="company"
          :company_id="company_id"
        ></BaseDatatable>
        <Dialog
          style=""
          header="Xóa"
          :visible.sync="showDeleteDialog"
          :contentStyle="{overflow: 'visible'}"
          :modal="true"
        >
          Bạn có chắc muốn xoá khu vực làm việc này không?
          <template
            #footer
          >
          <Button
          label="Hủy"
          @click="showDeleteDialog = false"
          icon="pi pi-times"
          class="p-button-warning callback-btn"
          />
          <Button label="Xóa" @click="deleteData()" icon="pi pi-check" class="p-button-danger" />
          </template>
        </Dialog>
        <Dialog header="Rất cảnh báo" :visible.sync="popupWarning" id="warning_poins_errs">
          <span class="txt-center">
            Bạn không thể xoá khu vực làm việc đang được thực hiện đánh giá.
          </span>
          <template
              #footer
              class="justify-content-center"
            >
            <Button label="Xác nhận" @click="popupWarning = false" icon="pi pi-check" class="" />
          </template>
        </Dialog>
      </div>
    </div>
  </div>
</template>

<script>
import DataServices from '@/core/DataServices'
import ApiRepository from "@/core/ApiRepository";
import BaseDatatable from './list'
import DropdownScrollable from '@/components/DropdownScrollable';
export default {
  components: {
    BaseDatatable,
    DropdownScrollable
  },
  data() {
    return {
      filters : {},
      filterOptions: {},
      options: [],
      listData: [],
      modelName: '',
      dataModel: null,
      title: '',
      componentKey: 0,
      page_transaction:null,
      editId: null,
      displayDialog: false,
      editDialogKey: 0,
      dialogMode: 'edit',
      deleteId: null,
      deleteName: null,
      showDeleteDialog: false,
      dataDelete :{},
      role: {
        view: false,
        add: false,
        edit: false,
        delete: false,
      },
      factory_obj: {
        loading: false,
        items: [],
        total: 0,
        offset: 0,
        limit: 20,
        filters: {},
      },
      company_id: null,
      company: {},
      company_obj: {
        loading: false,
        items: [],
        total: 0,
        offset: 0,
        limit: 20,
        filters: {},
      },
      popupWarning: false
    }
  },
  async created() {
    await this.initParams();
    if ((this.$store.getters?.type == this.$constants.TYPE_USER.SUPPER_ADMIN)) {
      await this.getListCompany()
    }
    this.modelName = this.$route.meta.model;
    this.dataModel = DataServices.getModel(this.modelName);
    //console.log('this.dataModel:',this.dataModel);
    // this.title = this.dataModel.name
    this.$store.commit('setLoading', true);
    if(this.$route.params.reload) {
      window.location.reload();
    }
    if (!this.$commonFuction.isEmpty(this.$route.query)){
      if (!this.$commonFuction.isEmpty(this.$route.query.company_id)){
        if ((this.$store.getters?.type == this.$constants.TYPE_USER.SUPPER_ADMIN)) {
          this.company = {id: this.$route.query.company_id};
          setTimeout(() => {
            const query = Object.assign({}, this.$route.query);
            delete query.company_id;
            this.$router.replace({ query });
          }, 100);
        }
      }
    }
    // var arr_role = await this.$CoreService.checkPermission(this.$constants.KEY_MENU.LIST_BANNER);
    // if (arr_role.indexOf(this.$constants.ROLE.VIEW) < 0){
    //   this.$router.push({path: this.$constants.URL_ERR.FOBIDDEN});
    // }
    // this.role.add = (arr_role.indexOf(this.$constants.ROLE.ADD) < 0) ? false:true;
    // this.role.edit = (arr_role.indexOf(this.$constants.ROLE.EDIT) < 0) ? false:true;
    // this.role.delete = (arr_role.indexOf(this.$constants.ROLE.DELETE) < 0) ? false:true;
  },
  watch: {
    '$route': 'initParams',
    async "company"() {
      if ((this.$store.getters?.type == this.$constants.TYPE_USER.SUPPER_ADMIN)) {
        this.company_id = this.company.id;
        await this.getListFactory();
        this.componentKey++;
      }
      //this.componentKey++;
    },
    async "company_id"() {
      if ((this.$store.getters?.type != this.$constants.TYPE_USER.SUPPER_ADMIN)) {
        this.company = {id: this.company_id};
        await this.getListFactory();
        //console.log("this.companythis.companythis.company", this.company);
        //this.componentKey++;
        
      }
    },
    async "$store.getters.company_id"() {
      if ((this.$store.getters?.type != this.$constants.TYPE_USER.SUPPER_ADMIN)) {
        this.$set(this,'company_id', (this.$store.getters?.type != this.$constants.TYPE_USER.SUPPER_ADMIN) ? this.$store.getters?.company_id : null);
        await this.getListFactory();
    //     //this.company = {id: this.company_id};
    //     //console.log("this.companythis.companythis.company", this.company);
    //     //this.componentKey++;
        
      }
    },
  },
  methods: {
    emitEvent(keyword) {
      this.$delete(this.company_obj.filters, 'name');
      if (keyword) {
        this.company_obj.filters.name = keyword;
      }
      this.getListCompany();
    },
    changeOffset(value) {
      this.company_obj.offset = value;
      // this.getListCompany();
    },
    async getListCompany() {
      var token = this.$store.getters.token ? this.$store.getters.token : null
      if(token){
        const headers = {
            "Authorization": "Bearer "+token,
        };
        this.company_obj.loading = true;
        await ApiRepository.post("/_api/company/options", {filters: this.company_obj.filters, limit: this.company_obj.limit, offset: this.company_obj.offset}, {headers}).then((res) => {
          if (this.company_obj.offset > 0) {
            this.company_obj.items.push(...res.data.data.company);
          } else {
            this.company_obj.items = res.data.data.company;
          }
          this.company_obj.total = res.data.data.total;
          this.company_obj.loading = false;
        }).catch((err) => {
            console.log(err);
            this.company_obj.loading = false;
        })
      }
    },
    async onEventOptions({event, key, data}) {
      if (key == "department") {
        this.factory_obj = data;
        if (event == 'offset') {
          await this.getListFactory();
        }
      }
    },
    async getListFactory() {
      if (this.$commonFuction.isEmptyObject(this.company)) {
        this.options["factory"] = [];
        return;
      }
      var token = this.$store.getters.token ? this.$store.getters.token : null
      if(token){
        const headers = {
            "Authorization": "Bearer "+token,
        };
        this.factory_obj.loading = true;
        if (!this.factory_obj?.filters) {
          this.factory_obj.filters = {};
        }
        this.factory_obj.filters.company_id = this.company?.id;
        await ApiRepository.post("/_api/factory/options", {filters: this.factory_obj.filters, limit: this.factory_obj.limit, offset: this.factory_obj.offset, company_id: this.company.id}, {headers}).then((res) => {
          if (this.factory_obj.offset > 0 ) {
            this.factory_obj.items.push(...res.data.data.factory);
          } else{
            this.factory_obj.items = res.data.data.factory;
          }
          this.factory_obj.total = res.data.data.total;
          this.factory_obj.loading = false;
          this.options["factory"] = this.factory_obj;
        }).catch((err) => {
            console.log(err);
            this.factory_obj.loading = false;
        })
      }
    },
    async initParams() {
      this.$store.commit('setLoading', true);
      if (this.$store.getters.type !== this.$constants.TYPE_USER.SUPPER_ADMIN) {
        this.company = {id : this.$store.getters?.company_id}
        this.company_id = this.$store.getters?.company_id;
        await this.getListFactory();
        // this.componentKey++
      }
      this.modelName = this.$route.meta.model;
      this.dataModel = DataServices.getModel(this.modelName);
      await this.$set(this, 'title', this.dataModel.label);
      //await this.$set(this, 'title', this.dataModel.label);
      // this.callbackOptions();
    },
    onChange() {
      this.$store.commit('setLoading', true);
      this.$apollo.queries.listData.refresh()
    },
    DataOnChange(data,f){
      if(f.type == 'Checkbox'){
      //   let dataUpdate = {}
      //   if(f.key == 'active'){
      //     dataUpdate['active'] = data[f.key]
      //   }
      //   let variables = {
      //     'data_update': dataUpdate,
      //     'where_key': {
      //       'id': {'_eq': data.id}
      //     }
      //   };
      //   this.$apollo.mutate({
      //     mutation: DataServices.updateData(this.modelName),
      //     variables: variables
      //   }).then(() => {})
      }
    },
    getFilterOptions(name) {
      var field = this.dataModel.getField(name)
      // console.log("field",field)
      var result = []
      if (field.type == 'Selection') {
        if (field.options ) result = field.options;
        else if(field.models && this.options[name]) result = this.options[name];
      } else {
        result = this.filterOptions[name] != null ? [...this.filterOptions[name]] : []
      }
      // console.log("result",result)
      return result;
    },
    getRowActions() {
      var actions = {}
      var that = this;
      if (that.$store.getters.controllers?.list_areas) {
        if (that.$store.getters.controllers?.list_areas.includes('add')) {
          actions.header = {name: 'add', icon: 'plus', path: `list-areas/add`};
        }
        // actions.header = { name: 'add', icon: 'plus'};
        actions.rows = function (rowData) {
          var buttons = {}
          //buttons.view = { name: 'view', icon: 'eye', key: 'id', path: `list-${that.modelName}/view/`};
          if (that.$store.getters.controllers?.list_areas.includes('edit')) {
            buttons.edit = {name: 'edit', icon: 'pencil', key: 'id', path: `list-areas/edit/`};
          }
          if (that.$store.getters.controllers?.list_areas.includes('delete')) {
            buttons.delete = {name: 'delete', icon: 'trash', key: 'id'};
          }
          if (that.dataModel.actions) {
            var modelaction = that.dataModel.actions(rowData)
            Object.assign(buttons, modelaction);
          }
          return buttons
        }
      } 
      return actions
    },
    async callbackOptions() {
      this.dataModel.getDisplayFields();
    //   var attributes = [];
    //   for (let index = 0; index < fields.length; index++) {
    //     const element = fields[index];
    //     if (element.models !== undefined && element.models !== null) {
    //       // console.log("SDFGHJK",element)
    //       var optionsData = [];
    //       attributes.push(element.models.key.key);
    //       attributes.push(element.models.display_key);
    //       var where_ = {}
    //       if( element['name']== "name_country"){
    //         // console.log("element",element)
    //         let {data} = await this.$apollo.query({
    //           query: DataServices.getList("country", {"fields" : "id country_lang{lang name}"}),
    //           variables: {
    //             where_key : {
    //               deleted : {_eq: false}
    //             },
    //             orderBy:[{ordinal: 'desc'},{created_at : 'desc'}]
    //           }
    //         })
    //         if (data) {
    //           var ress = data[Object.keys(data)];
    //           if (ress) {
    //             for (let index = 0; index < ress.length; index++) {
    //               const ele = ress[index];
    //               var name_country = ''
    //               if(ele.country_lang){
    //                 for (let j = 0; j < ele.country_lang.length; j++) {
    //                   if(ele.country_lang[j].lang == 'en'){
    //                     name_country = ele.country_lang[j].name;
    //                     break;
    //                   }
    //                 }
    //               }
    //               if(name_country !== ''){
    //                 optionsData.push({value: ele.id, label: name_country})
    //               }
    //             }
    //           }
    //         }
    //       }else{
    //         let {data} = await this.$apollo.query({
    //           query: DataServices.getList(element.models.tableName, {"fields" : attributes.join(',')}),
    //           variables: {where_key : where_}
    //         })
    //         if (data) {
    //           var result = data[Object.keys(data)];
    //           if (result) {
    //             for (let index = 0; index < result.length; index++) {
    //               const ele = result[index];
    //               optionsData.push({value: ele[attributes[0]], label: ele[attributes[1]]})
    //             }
    //           }
    //         }
    //       }
    //       // console.log("optionsData",optionsData)
    //       this.options[element.key] = optionsData;
    //     }
    //     this.componentKey++;
    //   }

    },
    async onActionClicked(payload) {
      var action = payload.action
      var data = null
      if (payload.data) {
        data = payload.data
      }
      var pageTransaction = (new Date()).getTime();
      switch (action.name) {
        case 'view':
          this.dialogMode = action.name
          if (action.path !== undefined && action.path) {
            this.$router.push({ path: action.path + data.data[action.key] })
          } else  {
            this.editId = data.data[action.key]
            this.displayDialog = true
            this.editDialogKey++
          }
          break
        case 'edit':
          this.dialogMode = action.name
          if (action.path !== undefined && action.path) {
            localStorage.setItem(pageTransaction.toString(), JSON.stringify(payload.lazyParams));
            this.$router.push({ path: action.path + data.data[action.key],query: { page_transaction: pageTransaction.toString(), company_id: this.company?.id }  })
          } else  {
            this.page_transaction = pageTransaction.toString();
            localStorage.setItem(pageTransaction.toString(), JSON.stringify(payload.lazyParams));
            this.editId = data.data[action.key]
            this.displayDialog = true
            this.editDialogKey++
          }
          break
        case 'delete':
          this.deleteId = data.data[action.key]
          this.deleteName = data.data.name_en
          this.dataDelete = data.data
          this.showDeleteDialog = true
          break
        case 'add':
          this.dialogMode = action.name
          if (action.path !== undefined && action.path) {
            this.$router.push({ path: action.path,query: { company_id: this.company_id } })
          } else  {
            this.displayDialog = true
            this.editDialogKey++
          }
          break
        case 'custom':
          await action.handler(data.data, this)
          this.componentKey++
          break
      }
    },
    async sleep(ms) {
      return new Promise((resolve) => {
        setTimeout(resolve, ms);
      });
    },
    async deleteData() {
      this.showDeleteDialog = false
      var token = this.$store.getters.token ? this.$store.getters.token : null
      if(token){
        const headers = {
          "Authorization": "Bearer "+token,
        };
        var that = this;
        await ApiRepository.post("/_api/area/delete", {area_id: that.deleteId, company_id: that.company.id}, {headers})
        .then(function () {
          that.$toast.add({ severity: 'success', summary: 'Thành công', detail: 'Xóa thành công', life: 3000 })
          that.$commonFuction.is_loading(false);
          that.componentKey += 1;
        }).catch((err) => {
          const error = err.response.data;
          if (error.message == "AREA_IS_EXIST_IN_SRA"){
            this.$toast.add({ severity: 'error', summary: 'Lỗi', detail: 'Khu vực làm việc đã tồn tại trong sra', life: 3000 });
          }
          else if (error.message == "AREA_HAVE_EVALUATION_FORM"){
            this.$toast.add({ severity: 'error', summary: 'Lỗi', detail: 'Khu vực làm việc đã tồn tại trong biểu mẫu đánh giá', life: 3000 });
          }
          else this.$toast.add({severity: 'error', summary: 'Lỗi', detail: 'Xóa dữ liệu thất bại', life: 3000});
        });
      }
    }
  },
  // apollo: {
  //   listData: {
  //     query() {
  //       this.modelName = this.$route.meta.model;
  //       return DataServices.getList(this.modelName);
  //     },
  //     variables () {
  //       // Use vue reactive properties here
  //       return this.whereKeyList;
  //     },
  //     update(data) {
  //       var listData = data[this.dataModel.tableName]
  //       this.title = this.dataModel.label + ' '
  //       this.dataModel.processData(listData)
  //       this.$store.commit('setLoading', false);
  //       this.componentKey += 1;
  //       return data[this.dataModel.tableName]
  //     },
  //     fetchPolicy: 'network-only',
  //     error() {
  //       this.$store.commit('setLoading', false);
  //     },
  //     skip() {
  //       return !this.modelName
  //     }
  //   }
  // }

}
</script>
<style lang="css">
.p-calendar .p-datepicker { width: 280px; padding: 0px; padding-top: 5px;}
.p-calendar .p-datepicker td, .p-calendar .p-datepicker td a {padding: 0px !important;}
.p-calendar .p-datepicker td span {padding: 0px !important; width: 30px !important; height: 30px !important;}
.p-datepicker .p-datepicker-header{padding: 5px !important;}
.p-button-warning-o .p-button-label-o{
  color: #e95d57;
}
.p-button-warning .pi-times{
  color: #e95d57;
}
</style>